<template>
  <navbar
    :class="[isNavFixed ? navbarFixed : '', isAbsolute ? absolute : '']"
    :color="isAbsolute ? 'text-white opacity-8' : ''"
    :minNav="navbarMinimize"
    v-if="showNavbar"
  />
  <div class="py-4 container-fluid">
    <div class="row mb-4">
      <div class="col-lg-12 position-relative z-index-2">
        <!-- Statistics Cards  -->
        <div class="row">
          <div class="col-lg-3 col-md-6 col-sm-6">
            <mini-statistics-card
              :title="{
                text: 'Original Files',
                value: dashboardData.total_original_reports,
              }"
              :icon="{
                name: 'description',
                color: 'text-white',
                background: 'dark',
              }"
            />
          </div>
          <div class="col-lg-3 col-md-6 col-sm-6 mt-lg-0 mt-4">
            <mini-statistics-card
              :title="{
                text: 'Processed Files',
                value: dashboardData.total_processed_reports,
              }"
              :icon="{
                name: 'check_circle',
                color: 'text-white',
                background: 'success',
              }"
            />
          </div>
          <div class="col-lg-3 col-md-6 col-sm-6 mt-lg-0 mt-4">
            <mini-statistics-card
              :title="{
                text: 'Zipped Files',
                value: dashboardData.zipped_reports,
              }"
              :icon="{
                name: 'folder_zip',
                color: 'text-white',
                background: 'info',
              }"
            />
          </div>
          <div class="col-lg-3 col-md-6 col-sm-6 mt-lg-0 mt-4">
            <mini-statistics-card
              :title="{
                text: 'Total URP Files',
                value: dashboardData.total_urp_files,
              }"
              :icon="{
                name: 'assignment',
                color: 'text-white',
                background: 'warning',
              }"
            />
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-lg-4 col-md-6 col-sm-6">
            <mini-statistics-card
              :title="{
                text: 'Pending URP Files',
                value: dashboardData.total_pending_urp_files,
              }"
              :icon="{
                name: 'pending',
                color: 'text-white',
                background: 'warning',
              }"
            />
          </div>
          <div class="col-lg-4 col-md-6 col-sm-6 mt-lg-0 mt-4">
            <mini-statistics-card
              :title="{
                text: 'Sent URP Files',
                value: dashboardData.total_sent_urp_files,
              }"
              :icon="{
                name: 'send',
                color: 'text-white',
                background: 'info',
              }"
            />
          </div>
          <div class="col-lg-4 col-md-6 col-sm-6 mt-lg-0 mt-4">
            <mini-statistics-card
              :title="{
                text: 'Committed URP Files',
                value: dashboardData.total_committed_urp_files,
              }"
              :icon="{
                name: 'done_all',
                color: 'text-white',
                background: 'success',
              }"
            />
          </div>
        </div>
        <!--  Charts -->
        <div class="row mt-2">
          <div class="col-lg-6 mt-0">
            <chart-holder-card
              title="File Processing Pipeline"
              subtitle="Current status overview"
              :update="`Updated: ${lastUpdated}`"
              color="white"
            >
              <reports-bar-chart
                ref="fileProcessingChart"
                id="file-processing-chart"
                :colors="[
                  'rgba(55, 65, 81, 0.9)', // Dark gray for Original
                  'rgba(239 , 68, 68, 0.9)', // Red for Processed
                  'rgba(251, 191, 36, 0.9)', // Yellow for Zipped
                ]"
              />
            </chart-holder-card>
          </div>

          <div class="col-lg-6 mt-0">
            <chart-holder-card
              title="URP File Status"
              subtitle="Distribution by status"
              :update="`Updated: ${lastUpdated}`"
              color="white"
            >
              <reports-bar-chart
                ref="urpStatusChart"
                id="urp-status-chart"
                :colors="[
                  'rgba(55, 65, 81, 0.9)', // Dark gray for Pending
                  'rgba(239, 68, 68, 0.9)', // Red for Sent
                  'rgba(251, 191, 36, 0.9)', // Yellow for Committed
                ]"
              />
            </chart-holder-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChartHolderCard from "./components/ChartHolderCard.vue";
import ReportsBarChart from "@/examples/Charts/ReportsBarChart.vue";
import MiniStatisticsCard from "./components/MiniStatisticsCard.vue";
import axios from "axios";

export default {
  name: "dashboard-default",
  components: {
    ChartHolderCard,
    ReportsBarChart,
    MiniStatisticsCard,
  },
  data() {
    return {
      lastUpdated: "",
      dashboardData: {
        total_original_reports: 0,
        total_processed_reports: 0,
        zipped_reports: 0,
        total_urp_files: 0,
        total_pending_urp_files: 0,
        total_sent_urp_files: 0,
        total_committed_urp_files: 0,
      },
      isLoading: false,
    };
  },
  mounted() {
    this.fetchDashboardData();
  },
  methods: {
    getFileProcessingChartData() {
      // Create plain primitive values
      const val1 = +(this.dashboardData.total_original_reports || 0);
      const val2 = +(this.dashboardData.total_processed_reports || 0);
      const val3 = +(this.dashboardData.zipped_reports || 0);

      return {
        labels: ["Original", "Processed", "Zipped"],
        datasets: {
          label: "Files",
          data: [val1, val2, val3],
        },
      };
    },

    getUrpStatusChartData() {
      // Create plain primitive values
      const val1 = +(this.dashboardData.total_pending_urp_files || 0);
      const val2 = +(this.dashboardData.total_sent_urp_files || 0);
      const val3 = +(this.dashboardData.total_committed_urp_files || 0);

      return {
        labels: ["Pending", "Sent", "Committed"],
        datasets: {
          label: "URP Files",
          data: [val1, val2, val3],
        },
      };
    },

    updateCharts() {
      // Wait for next tick to ensure refs are available
      this.$nextTick(() => {
        if (this.$refs.fileProcessingChart) {
          const chartData = this.getFileProcessingChartData();
          console.log("Updating file processing chart with:", chartData);
          this.$refs.fileProcessingChart.updateChart(chartData);
        } else {
          console.warn("fileProcessingChart ref not available");
        }

        if (this.$refs.urpStatusChart) {
          const chartData = this.getUrpStatusChartData();
          console.log("Updating URP status chart with:", chartData);
          this.$refs.urpStatusChart.updateChart(chartData);
        } else {
          console.warn("urpStatusChart ref not available");
        }
      });
    },

    async fetchDashboardData() {
      if (this.isLoading) return;
      this.isLoading = true;

      const endpoints = [
        "/dashboard/original-files/",
        "/dashboard/processed-files/",
        "/dashboard/zipped-files/",
        "/dashboard/urp-files/",
        "/dashboard/pending-urp-files/",
        "/dashboard/sent-urp-files/",
        "/dashboard/committed-urp-files/",
      ];

      try {
        const responses = await Promise.all(
          endpoints.map((endpoint) =>
            axios
              .get(endpoint)
              .then((res) => {
                if (!res || !res.data) {
                  console.error(`API call returned no data for ${endpoint}`);
                  return null;
                }
                return res.data;
              })
              .catch((err) => {
                console.error(`Network error for ${endpoint}:`, err);
                return null;
              }),
          ),
        );

        console.log("API Responses:", responses);

        // Update dashboard data with plain values
        this.dashboardData = {
          total_original_reports: responses[0]?.total_original_reports || 0,
          total_processed_reports: responses[1]?.total_processed_reports || 0,
          zipped_reports: responses[2]?.zipped_reports || 0,
          total_urp_files: responses[3]?.total_urp_files || 0,
          total_pending_urp_files: responses[4]?.total_pending_urp_files || 0,
          total_sent_urp_files: responses[5]?.total_sent_urp_files || 0,
          total_committed_urp_files:
            responses[6]?.total_committed_urp_files || 0,
        };

        this.lastUpdated = new Date().toLocaleTimeString();
        console.log("Dashboard data updated:", this.dashboardData);

        // Update charts after data is loaded with a slight delay
        this.$nextTick(() => {
          setTimeout(() => {
            this.updateCharts();
          }, 100);
        });
      } catch (err) {
        console.error("Dashboard fetch error:", err);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
